define.alias("shared/components/shared/guidelines", "settings/components/shared/guidelines");